import React from 'react';

const Comments = props => {
    return (
        <div className='ordering-tab-wrapper' />
    );
};

export default Comments;